import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class MinExpression extends ExpressionRule {
    readonly __type: string = "Min";
    value1: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();

        let dd = new NumberDataDefinition();
        dd.list = true;

        this.value1 = ExpressionValue.createExpressionValue(this, "minValue", dd);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return Math.min(...this.value1.evaluate(data, testContext));
    }
}
